import { Info } from 'lucide-react';

import { StyledContainer, StyledText } from './SurveyErrorMessage.styles';

const SurveyErrorMessage = ({ message }: { message: string }) => {
  return (
    <StyledContainer>
      <Info stroke="#eb5757" />
      <StyledText>{message}</StyledText>
    </StyledContainer>
  );
};

export default SurveyErrorMessage;
